import { produce } from 'immer';
import { sendRequest } from '../api/websocketApi';
import useStore from '../store/store';
import type { Member } from './getMembers';

export interface AddMemberParams {
    firstName: string;
    lastName: string;
    sex: 'male' | 'female';
    birthDate: Date;
    patientId?: string;
    referringPhysician?: string;
    ethnicity?: string;
}

interface APIResponse {
    success: boolean;
    errCode?: 'invalid_token' | 'auth_failed';
    errDetails?: string;
    memberId?: number;
    insertionDate?: Date;
}

const AddMember = (params: AddMemberParams) => {
    const setFormError = useStore.getState().setFormError;
    const setIsLoading = useStore.getState().setIsLoading;
    const members = useStore.getState().members;
    const setMembers = useStore.getState().setMembers;

    setIsLoading(true);
    sendRequest(
        {
            endpoint: '/member/add',
            body: params,
        },
        (data: APIResponse) => {
            const { success, memberId, insertionDate, errCode, errDetails } =
                data;
            if (success && memberId) {
                const newMembers = produce(members, (draft: Member[]) => {
                    draft.push({
                        MemberId: memberId,
                        FirstName: params.firstName,
                        LastName: params.lastName,
                        Sex: params.sex,
                        BirthDate: params.birthDate,
                        PatientId: params.patientId,
                        ReferringPhysician: params.referringPhysician,
                        Ethnicity: params.ethnicity,
                        InsertionDate: insertionDate,
                        ReadyKitCount: 0,
                        InProgressKitCount: 0,
                    });
                });
                setMembers(newMembers);
                setIsLoading(false);
            } else if (!success && errCode) {
                setIsLoading(false);
                setFormError('');
                setTimeout(() => setFormError(errCode), 0);
                console.error(errCode);
                if (errDetails) console.error(errDetails);
            }
        }
    );
};

export default AddMember;
